import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import crossIcon from "assets/images/sbs/cross-bg.png";
import userImg from "assets/images/sbs/user1.png";
import downloadIcon from "assets/images/sbs/download-icon.png";
import uploadIcon from "assets/images/sbs/upload-icon.png";
import searchIcon from "assets/images/sbs/search.png";
import { Button } from "reactstrap";
import { uploadFile } from "react-s3";
import Alert from "../../shared/common/alert";
import { withRouter } from "react-router";
import moment from "moment";
import cx from "classnames";
import dummyAvatar from "assets/images/sbs/dummyAvatar.png";

import Socket from "socket/socket";
import * as loaderAction from "redux/loader/action";
import { compose } from "redux";
import { connect } from "react-redux";

const config = {
  bucketName: "gameapart-assets",
  dirName: "LTS",
  region: "us-east-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
};

function LoadUploadQuestions(props) {
  const [browseFilesObject, setBrowseFilesObject] = useState({});
  const [nameOfSetForUpload, setNameOfSetForUpload] = useState("");
  const [linkLocationCSV, setLinkLocationCSV] = useState("");
  const [deleteSetModal, setDeleteSetModal] = useState(false);
  const [browseFileName, setBrowseFileName] = useState("");

  const [confirmSetModal, setConfirmSetModal] = useState(false);
  const [disableUploadBtn, setDisableUploadBtn] = useState(true);
  const [selectedSet, setSelectedSet] = useState();
  console.log(nameOfSetForUpload, "nameOfSetForUploadnameOfSetForUpload");
  console.log(linkLocationCSV, "linkLocationCSVlinkLocationCSVlinkLocationCSV");

  const current_user = _.get(props, "gameReducer.currentUser");
  const roomData = _.get(props, "gameReducer.roomObj");
  const params = _.get(props, "paramsReducer.gameObj.1_chooseasker");
  const allQuestionSets = _.get(roomData, "game_state.team_question_sets");

  const handle_browse_files = useRef();
  const downloadTemplate = () => {
    window.open(`${params?.upload?.download_link}`, "_blank");
  };
  useEffect(() => {
    if (nameOfSetForUpload !== "" && linkLocationCSV !== "") {
      setDisableUploadBtn(false);
    } else {
      setDisableUploadBtn(true);
    }
  }, [nameOfSetForUpload, linkLocationCSV]);
  const invalidQuestionSet = (error) => {
    Alert(400, error.error);
  };

  useEffect(() => {
    return Socket.addListener(
      "lt-upload-question-set",
      () => {},
      invalidQuestionSet
    );
  }, []);
  const handle_file = (e) => {
    if (e.target.files.length > 0) {
      // props.setIsLoading(true);
      let file = e.target.files[0];
      setBrowseFileName(file?.name);
      console.log(file, "filefilefilefile");

      uploadFile(file, config)
        .then((data) => {
          console.log(data, "asdfghjk");
          setBrowseFilesObject(data);
          setLinkLocationCSV(data?.location);
          // props.setIsLoading(false);
          // handle_hero_link(data.location, "pdf");
        })
        .catch((err) => console.error(err, "file data err"));
    }
  };
  // const onSubmitQuestions = () => {
  //   let data = {
  //     action: "lt-submit-question",
  //     roomId: roomData?.id,
  //     questions: questionsData,
  //   };
  //   Socket.sendMessage(data);
  //   setShowConfirmQuestionsModal(false);
  // };
  const onDeleteSet = (setID) => {
    let data = {
      action: "lt-remove-question-set",
      roomId: roomData?.id,
      setId: setID
    };
    Socket.sendMessage(data);
    setDeleteSetModal(false);
    setConfirmSetModal(false);
  };
  const onConfirmSet = (setID) => {
    let data = {
      action: "lt-submit-question",
      roomId: roomData?.id,
      setId: setID
    };
    Socket.sendMessage(data);
    setConfirmSetModal(false);
  };
  const onUploadSet = () => {
    let data = {
      action: "lt-upload-question-set",
      roomId: roomData?.id,
      file: browseFilesObject?.key,
      title: nameOfSetForUpload,
      owner: current_user?.userId,
      team_id: current_user?.team.id,
      displayName: current_user?.username ? current_user?.username : "",
      profileImage: current_user?.picture ? current_user?.picture : ""
    };
    Socket.sendMessage(data);
  };
  const handleSelectSet = (e, currentSet) => {
    console.log(currentSet.profileImage, "wwwwwwwwwwwwwwwwww");
    if (e.target.className === "close-icon") {
      setSelectedSet(currentSet);
      setDeleteSetModal(true);
    } else {
      setSelectedSet(currentSet);
      setConfirmSetModal(true);
    }
  };

  return (
    <div className="set-file-main">
      <h4 className="set-txt">Choose a set below</h4>
      <div className="set-file-container">
        <div className="set-file-flex">
          {allQuestionSets?.map((currentSet) => {
            return (
              <div
                onClick={(e) => handleSelectSet(e, currentSet)}
                className={cx("set-file-card", {
                  active: selectedSet === currentSet
                })}
              >
                <img src={crossIcon} className="close-icon" alt="crossIcon" />
                <h2 className="title">{currentSet.title}</h2>
                <p className="date">
                  {moment(currentSet.submitted_timestamp).format(
                    "DD MMM[,] YYYY"
                  )}
                </p>
                <div className="set-file-player">
                  {/* <img
                    style={{
                      backgroundImage: `url(${
                        currentSet?.profileImage
                          ? currentSet?.profileImage
                          : dummyAvatar
                      })`,
                    }}
                    className="pla-img"
                    alt=""
                  /> */}
                  <div
                    className="pla-img"
                    style={{
                      backgroundSize: "contain",
                      backgroundImage: `url(${
                        currentSet?.profileImage !== "profileImage"
                          ? currentSet?.profileImage
                          : dummyAvatar
                      })`
                    }}
                  ></div>
                  <p className="name">{currentSet?.displayName}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {confirmSetModal && (
        <div className="sbs-modal-container">
          <div className="sbs-modal-dialog">
            <div className="sbs-modal-content">
              {/* <p>Confirm</p> */}
              {/* <h5 className="num"></h5> */}
              <p className="question">
                Are you sure you want to open the question set "
                {selectedSet?.title}" ?
              </p>
              <Button
                onClick={() => setConfirmSetModal(false)}
                className="back-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={() => onConfirmSet(selectedSet?.set_id)}
                className="confirm-btn"
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}

      {deleteSetModal && (
        <div className="sbs-modal-container">
          <div className="sbs-modal-dialog">
            <div className="sbs-modal-content">
              {/* <p>Confirm</p> */}
              {/* <h5 className="num"></h5> */}
              <p className="question">
                {" "}
                Are you sure you want to delete the question set "
                {selectedSet?.title}" ?
              </p>
              <Button
                onClick={() => setDeleteSetModal(false)}
                className="back-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={() => onDeleteSet(selectedSet?.set_id)}
                className="confirm-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      )}
      <p className="upload-txt">Upload with Template</p>
      <Button onClick={() => downloadTemplate()} className="download-btn">
        <img src={downloadIcon} alt="" /> Download a template
      </Button>
      <div className="set-file-options-wrapper">
        <div className="set-file-options">
          <div className="text-left">
            <label htmlFor="">Choose your file</label>
            {/* <input
              type="text"
              className="form-control set-file-input"
              placeholder="Questions.csv"
            /> */}
            <input
              readOnly
              type="text"
              placeholder={params?.upload?.file_hint}
              className="form-control set-file-input"
              value={browseFileName}
              // onChange={(e) => handle_hero_link(e.target.value, "pdf")}
            />
          </div>
          <button
            onClick={() => handle_browse_files.current.click()}
            className="search-btn"
          >
            <img src={searchIcon} alt="" />
            <input
              type="file"
              ref={handle_browse_files}
              onChange={(e) => handle_file(e)}
              style={{ display: "none" }}
            />
          </button>
          <div className="text-left">
            <label htmlFor="">Name your set</label>
            <input
              type="text"
              className="form-control set-file-input"
              placeholder={params?.upload?.name_hint}
              value={nameOfSetForUpload}
              onChange={(e) => setNameOfSetForUpload(e.target.value)}
            />
          </div>
          <button
            onClick={() => {
              onUploadSet();
            }}
            disabled={disableUploadBtn}
            className={cx("upload-btn", {
              uploadDisabledBtn: disableUploadBtn
            })}
          >
            <img src={uploadIcon} alt="" />
            Upload File{" "}
          </button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LoadUploadQuestions);
